<template>
  <span>{{text}}</span>
</template>

<script>
  export default {
    name: 'notification-template',
  }
</script>
